import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ConfirmDialog from './ConfirmDialog';

class ConfirmCancelDialog extends Component {
  render() {
    const {
      open,
      onClose,
      onConfirm,
    } = this.props;

    return (
      <ConfirmDialog
        message="You have unsaved changes, are you sure you want to cancel?"
        open={open}
        onClose={onClose}
        onConfirm={onConfirm}
      />
    );
  }
}

ConfirmCancelDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
};

ConfirmCancelDialog.defaultProps = {
  open: false,
  onConfirm: () => {},
};

export default ConfirmCancelDialog;
